import {
  useCallback,
  useEffect,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Form from 'react-bootstrap/Form';

import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { useForm, FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import {
  setDataOCR,
  setDocumentType,
  setErrorOcr,
  setImageSide,
  setIntentsSearchSign,
  setNationality,
  setWayCaptureDocument,
} from '../../app/store/ocrSlice';
import { setErrorMajestic, setIsLoading, setShowAllowFormats } from '../../app/store/majesticSlice';
import { cleanBase64, getYearsBirthByArrivalDate, isEmptyObject } from '../../utils';
import DocumentTypeSelector from './components/DocumentTypeSelector';
import CountryExtendedList from '../../utils/CountryExtendedList';
import CountrySelect from '../../ui/Form/CountrySelect.';
import { useRecognizePassportMutation } from '../../services/ocrApi';
import usePageNavigation from '../../hooks/usePageNavigation';
import ErrorMessageOcrModal from '../../ui/Modals/ErrorMessageOcrModal';
import CustomErrorModal from '../../ui/Modals/CustomErrorModal';
import InputFile from './components/InputFile';
import RecomendationPhotosModal from '../../ui/Modals/RecomendationPhotosModal';
import useVerifyGuestType from '../../hooks/useVerifyGuestType';

function GuestDocumentFrontPage() {
  const {
    documentType,
    nationality,
    intentsSearchSign,
    imageFront,
    imageReverse,
  } = useSelector((state) => state.ocr);
  const { booking } = useSelector((state) => state.booking);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedNationality, setSelectedNationality] = useState({});
  const [showRecomendationModal, setShowRecomendationModal] = useState(false);
  const [existError, setExistError] = useState(false);
  const [existSignature, setExistSignature] = useState(true);
  const [recognizePassport,
    {
      isError: isErrorPassport,
    },
  ] = useRecognizePassportMutation();

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const methods = useForm({
    defaultValues: {
      nationality: {},
      documentType: '',
    },
  });

  const {
    control,
    getValues,
    formState: { errors, isValid },
    handleSubmit,
    setValue,
    trigger, // Metodo para validar manualmente
  } = methods;

  const { navigateNextPage } = usePageNavigation();
  const { verifyGuestType } = useVerifyGuestType();

  useEffect(() => {
    dispatch(setIsLoading(false));

    // dispatch(setImageSide({ imageSide: 'clean' }));
    dispatch(setImageSide({ imageSide: 'imageFront' }));
    dispatch(setImageSide({ imageSide: 'imageReverse' }));

    return () => {
      dispatch(setIsLoading(false));
    };
  }, [dispatch]);

  const checkIsValid = useCallback(async () => {
    await trigger(); // Valida todos los campos
  }, [trigger]);

  const handleGetSignPassport = () => {
    setExistSignature(true);
    dispatch(setIntentsSearchSign(intentsSearchSign + 1));
    dispatch(setShowAllowFormats({ show: true }));
  };

  useEffect(() => {
    if (documentType !== '' && nationality !== '') {
      setValue('nationality', nationality);
      setValue('documentType', documentType);
      setSelectedNationality(nationality);
      checkIsValid();
    }
  }, [setValue, checkIsValid, documentType, nationality]);

  const onSubmit = (data) => {
    // console.log(data);
    /* dispatch(setDocumentType(data.documentType));
    dispatch(setNationality(data.nationality));
    dispatch(setWayCaptureDocument('byScanner'));
    navigateNextPage('DocumentFrontCapture'); */
    // navigate('/DocumentFrontCapture');
  };

  const onButtonClick = async () => {
    // setAllowFormats(true);
    dispatch(setShowAllowFormats({ show: true }));
    // dispatch(setNationality(getValues('nationality')));
  };

  const handleShowRecomendationModal = () => {
    setShowRecomendationModal(true);
  };

  const handleConfirmRecomendationPhoto = () => {
    const data = getValues();
    // console.log('handleConfirmRecomendationPhoto', data);
    dispatch(setDocumentType(data.documentType));
    dispatch(setNationality(data.nationality));
    dispatch(setWayCaptureDocument('byScanner'));
    navigateNextPage('DocumentFrontCapture');
  };

  const handleChange = (selectedOption) => {
    // console.log('Seleccionado:', selectedOption);
    if (typeof selectedOption !== 'undefined' && !isEmptyObject(selectedOption)) {
      if (!['MX', 'DO'].includes(selectedOption.iso2)) {
        setValue('documentType', 'PASSPORT');
      }
      setSelectedNationality(selectedOption);
      checkIsValid();
    }
  };

  const handleOnMenuOpen = () => {
    setIsMenuOpen(true);
    // setSelectedNationality({});
    setValue('documentType', '');
  };

  const handleOnMenuClose = () => {
    setIsMenuOpen(false);
  };

  const handleChangeErrorExist = () => {
    setExistError(false);
  };

  const handlerRecognizePassport = async (base64 = '', documentSide = '', fileType = '') => {
    console.log('handlerRecognizePassport', { documentSide });
    // dispatch(setImageSide({ imageSide: documentSide, imageData: base64, fileType }));
    const { data } = await recognizePassport({
      imageFront: cleanBase64(documentSide === 'imageFront' ? base64 : imageFront),
      imageBack: cleanBase64(documentSide === 'imageReverse' ? base64 : imageReverse),
      numberReservation: booking.NumReserva,
      documentType: fileType,
    }).unwrap();

    if (!data.front.signature && intentsSearchSign < 1) {
      dispatch(setIsLoading(false));
      setExistSignature(false);
      dispatch(setErrorOcr({ messageFormatted: t('TXT_NOT_FOUND_SIGN_ON_IMAGE') }));
      return;
    }

    const verifyGuest = verifyGuestType(data?.front?.birthDate || null);

    if (!verifyGuest.isMatchGuest) {
      const message = t(
        'TXT_WARNING_NO_MACTH_GUEST_TYPE',
        {
          typeDocument: t(`TXT_${documentType}`).toLowerCase(),
          guestBirthday: `${parseInt(verifyGuest.selectedGuest.Edad, 10)}-${verifyGuest.initGuestType.tagkey}`,
          documentBirthday: `${parseInt(getYearsBirthByArrivalDate(data.birthDate, booking.FechaEntrada), 10)}-${verifyGuest.foundGuest.tagkey}`,
        },
      );
      dispatch(setIsLoading(false));
      dispatch(setErrorMajestic({ message }));
      setExistError(true);
      return; // Stop propagation
    }

    dispatch(setDataOCR(data));
    navigateNextPage('DocumentationReview');
  };

  const handlerSetImageSide = (documentSide, imageData, fileType) => {
    dispatch(setImageSide({ imageSide: documentSide, imageData, fileType }));
  };

  const handleFileLoaded = (data) => {
    const { documentSide, fileType, imageData } = data;
    // console.log('data', data);
    dispatch(setImageSide({ imageSide: documentSide, imageData, fileType }));
    dispatch(setNationality(getValues('nationality')));
    if (documentSide === 'imageFront' && fileType !== 'pdf') {
      navigateNextPage('DocumentPreview');
      return;
    }
    handlerRecognizePassport(imageData, documentSide, fileType);
  };

  const onError = (errorList) => {
    console.log(errorList);
  };

  return (
    <div className="guest__document position-relative">
      <div className="text-center">
        <p className="mb-0 app-txt-granite pp-fw-figtree-regular">{t('TXT_TITLE_CHECK_IN')}</p>

        <p className="mt-3 mb-0 app-fs-h4 app-lh-h4 app-txt-granite app-fw-notosans-bold">{t('TXT_DOCUMENTATION')}</p>
      </div>
      <FormProvider
        control={methods.control}
        handleSubmit={methods.handleSubmit}
        setValue={methods.setValue}
        getValues={methods.getValues}
        watch={methods.watch}
        formState={methods.formState}
        register={methods.register}
        trigger={methods.trigger}
      >
        <Form onSubmit={handleSubmit(onSubmit, onError, onButtonClick)} className="mt-3">
          <Card className="border-0 mb-3">
            <Card.Body className="p-0">
              <div className="text-center mb-3">
                <p
                  // className={`mb-1 lh-sm app-txt-${errors.nationality ? 'red' : 'gray'}`}
                  className="mb-1 lh-sm app-txt-granite-80-dark"
                >
                  {t('TXT_SELECT_NATIONALITY')}
                </p>
              </div>
              <CountrySelect
                control={control}
                name="nationality"
                formLabel={t('TXT_NATIONALITY')}
                placeHolder={t('TXT_SELECT_NATIONALITY')}
                rules={{ required: t('TXT_ERROR_INPUT_COUNTRY_NATIONALITY') }}
                defaultValue={selectedNationality}
                options={CountryExtendedList}
                classNamePrefix="form-review"
                handleOnChange={handleChange}
                controlHeight={24}
                handleOnMenuOpen={handleOnMenuOpen}
                handleOnMenuClose={handleOnMenuClose}
                // styles={{ width: '150px' }}
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-granite-80-light',
                  cardBody: 'py-',
                  label: 'app-fs-12 app-txt-granite-80-dark app-fw-notosans-bold text-uppercase',
                }}
              />
            </Card.Body>
          </Card>
          <InputFile
            // ref={inputFileRef}
            handlerPassport={handlerRecognizePassport}
            handlerSetImageSide={handlerSetImageSide}
            onFileLoaded={(data) => handleFileLoaded(data)}
          />
          <AnimatePresence>
            {!isEmptyObject(selectedNationality) && !isMenuOpen && (
              <motion.div
                initial={{ opacity: 0 }} // Inicia oculto
                animate={{ opacity: 1 }} // Se anima a 1 (visible)
                exit={{ opacity: 0 }} // Se anima a 0 (oculto) al salir
                transition={{ duration: 0.5 }} // Transición suave
              >
                <Card className="border-0">
                  <Card.Body>
                    <div className="text-center">
                      <p
                        // className={`mb-2 app-txt-${errors.documentType ? 'red' : 'gray'}`}
                        className={`mb-4 app-txt-${errors.documentType ? 'red' : 'granite-80-dark'}`}
                      >
                        {t('TXT_SELECT_DOCUMENT')}
                      </p>
                    </div>

                    <DocumentTypeSelector />

                    <div className="mt-3">
                      <Button
                        variant=""
                        type="button"
                        disabled={!isValid}
                        className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height border-0"
                        onClick={handleShowRecomendationModal}
                      >
                        {t('TXT_TAKE_PHOTO')}
                      </Button>
                      <Button
                        variant="link"
                        type="button"
                        disabled={!isValid}
                        className="bg-transparent app-fw-notosans-bold app-txt-gold w-100 rounded-3 btn-height border-0 mt-2 px-0"
                        onClick={onButtonClick}
                      >
                        {t('TXT_ATTACH_FILE')}
                      </Button>
                      {/* <input
                        type="file"
                        id="directScience_fileInput"
                        name="document"
                        accept="image/png, image/jpeg, application/pdf"
                        style={{ display: 'none' }}
                        ref={fileInputRef}
                        onChange={onFileChange}
                      /> */}
                    </div>
                  </Card.Body>
                </Card>
              </motion.div>
            )}
          </AnimatePresence>
        </Form>
      </FormProvider>
      {isErrorPassport && <ErrorMessageOcrModal />}
      {!existSignature && <ErrorMessageOcrModal handleCloseModal={handleGetSignPassport} />}
      {existError && <CustomErrorModal handleCloseModal={handleChangeErrorExist} />}
      {showRecomendationModal && (
        <RecomendationPhotosModal
          showModal
          handleConfirmAttachment={handleConfirmRecomendationPhoto}
          handleHideFormatsModal={() => setShowRecomendationModal(false)}
        />
      )}
    </div>
  );
}

export default GuestDocumentFrontPage;
